import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { ozarkMOConfig } from "./data";

export default function OzarkMOPage() {
  return <CityPageTemplate config={ozarkMOConfig} />;
}